import React, {useContext} from "react"
import Cookies from "js-cookie"
import {App, FloatButton, Tooltip} from 'antd'
import {FaBars, FaSignInAlt, FaSignOutAlt, FaSuitcase, FaTaxi, FaUserAlt, FaQuestion} from "react-icons/fa"
import {ActionType, API, Enum} from "../../resources/constants"
import language from "../../resources/languages/fa_IR"

// Contexts
import GlobalContext from "../../contexts/global"
import AxiosContext from '../../contexts/axios'

// Interfaces
import {AxiosError, AxiosResponsePaginate} from "../../interfaces/axios"

const { Components: { Menu }, Message: MessageLanguage } = language
const { SET_OPEN_DRAWER, SET_FORM, SET_USER, SET_TRAVEL_MOD, SET_TRAVEL, SET_IS_OPEN_FLOAT_BUTTON, SET_FILTER, SET_DESTINATION, SET_DESTINATION_LOCATION, SET_ORIGIN, SET_ORIGIN_LOCATION, SET_DIRECTIONS } = ActionType
const { TRAVEL_TRAVEL_PAGINATE, TRAVEL_TRAVEL_MY_PAGINATE } = API;
const { Form, TravelMod, Message } = Enum

export default function Index() {
    const { filter, user, travelMod, isOpenFloatButton, openDrawer, dispatch } = useContext(GlobalContext)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    const getTravel = (travelMod: string) => {
        dispatch({ type: SET_FILTER , payload: { filter: {} }})
        axios.post(travelMod === TravelMod.NEW ? TRAVEL_TRAVEL_PAGINATE : TRAVEL_TRAVEL_MY_PAGINATE, {}, { params: { page: 1, limit: 1 }}).then((response: AxiosResponsePaginate) => {
            const { data, data: { docs } } = response
            const travel =  docs.length ? { ...docs[0], paginate: { ...data, docs: null } } : {}
            dispatch({ type: SET_TRAVEL , payload: { travel }})
            dispatch({ type: SET_TRAVEL_MOD , payload: { travelMod }})
            resetDirections()
        }).catch( (error: AxiosError) => {
            const { response: { data } } = error;
            dispatch({ type: SET_TRAVEL , payload: { travel: {} }})
            resetDirections()
            // @ts-ignore
            message.error(MessageLanguage[Message.ERROR_REQUEST]).then(response => response)
        })
    }

    const resetDirections = () => {
        dispatch({ type: SET_DESTINATION , payload: { destination: null }})
        dispatch({ type: SET_DESTINATION_LOCATION , payload: { destinationLocation: null }})
        dispatch({ type: SET_ORIGIN , payload: { origin: null }})
        dispatch({ type: SET_ORIGIN_LOCATION , payload: { originLocation: null }})
        dispatch({ type: SET_DIRECTIONS , payload: { directions: { routes: [] } }})
    }

    return (
        <Tooltip placement="top" title={Menu.menu} open={!openDrawer && !isOpenFloatButton}>
        <FloatButton.Group
            trigger="click"
            type="primary"
            style={{ right: 30, bottom: 15 }}
            icon={<FaBars size={26} />}
            open={isOpenFloatButton}
            onOpenChange={isOpen => (isOpen !== isOpenFloatButton) && dispatch({ type: SET_IS_OPEN_FLOAT_BUTTON , payload: { isOpenFloatButton: isOpen }})}
        >
            <Tooltip align={{offset: [-12, -12] }}  overlayClassName={travelMod === TravelMod.NEW ? 'menu-tooltip menu-tooltip-active' : 'menu-tooltip'} placement="leftTop" title={Menu.newTravel} open={true}>
                <FloatButton icon={<FaTaxi />} className={travelMod === TravelMod.NEW ? 'menu-float-button-active' : undefined} onClick={() => getTravel(TravelMod.NEW)} />
            </Tooltip>
            {
                user ? (
                  <>
                      <Tooltip align={{offset: [-12, -12] }} overlayClassName={travelMod === TravelMod.MY ? 'menu-tooltip menu-tooltip-active' : 'menu-tooltip'} placement="leftTop" title={Menu.oldTravel} open={true}>
                          <FloatButton icon={<FaSuitcase />} className={travelMod === TravelMod.MY ? 'menu-float-button-active' : undefined} onClick={() => getTravel(TravelMod.MY)} />
                      </Tooltip>
                      <Tooltip align={{offset: [-12, -12] }} overlayClassName={'menu-tooltip'} placement="leftTop" title={Menu.profile} open={true}>
                          <FloatButton icon={<FaUserAlt />} onClick={() => {
                              dispatch({ type: SET_FORM , payload: { form: Form.PROFILE }})
                              dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
                          }} />
                      </Tooltip>
                      <Tooltip align={{offset: [-12, -12] }} overlayClassName={'menu-tooltip'} placement="leftTop" title={Menu.signOut} open={true}>
                          <FloatButton icon={<FaSignOutAlt />} onClick={() => {
                              Cookies.remove('accessToken')
                              dispatch({ type: SET_USER , payload: { user: null }})
                              getTravel(TravelMod.NEW)
                              message.success(MessageLanguage[Message.SIGN_OUT_PROFILE]).then(response => response)
                          }} />
                      </Tooltip>
                  </>
                ) : (
                  <Tooltip align={{offset: [-12, -12] }} overlayClassName={'menu-tooltip'} placement="leftTop" title={Menu.signIn} open={true}>
                      <FloatButton icon={<FaSignInAlt />} onClick={() => {
                          dispatch({ type: SET_FORM , payload: { form: Form.SIGN_IN }})
                          dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
                      }} />
                  </Tooltip>
                )
            }
            <Tooltip align={{offset: [-12, -12] }} overlayClassName={'menu-tooltip'} placement="leftTop" title={Menu.why} open={true}>
                <FloatButton icon={<FaQuestion style={{transform:'scaleX(-1)'}} />} onClick={() => {
                    dispatch({ type: SET_FORM , payload: { form: Form.SAFAR30 }})
                    dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
                }} />
            </Tooltip>
        </FloatButton.Group>
        </Tooltip>
    );
};
